import React from 'react';
import TimelineStepsContainer from './styles';
import IconInformation from './styles';
import Check from '~/assets/images/check_blue.svg';
import moment from 'moment';
import TruckIcon from '~/assets/images/truck.png';

export default function TimelineStepsLogistic(props) {
  const steps = [
    {
      title: 'Pedido',
      description: props.stepsInfo.description,
      date: props.stepsInfo.dateBegin,
      active: props.title === 'Pedido',
      purple: props.title === 'Financeiro' || props.title === 'Faturamento' || props.title === 'Liberação' || props.title === 'Saída',
    },
    {
      title: 'Financeiro',
      description: props.stepsInfo.description,
      active: props.title === 'Financeiro',
      purple: props.title === 'Faturamento' || props.title === 'Liberação' || props.title === 'Saída',
    },
    {
      title: 'Faturamento',
      description: props.stepsInfo.description,
      active: props.title === 'Faturamento',
      purple: props.title === 'Liberação' || props.title === 'Saída',
    },
    {
      title: 'Liberação',
      description: props.stepsInfo.description,
      active: props.title === 'Liberação',
      purple: props.title === 'Saída',
    },
    {
      title: 'Saída',
      description: props.stepsInfo.description,
      date: props.stepsInfo.dateEnd,
      active: props.title === 'Saída',
    },
  ];

  const isMobile = window.screen.width < 771;
  const statusReleasedForDelivery = 'Liberado para entrega ou retirada'

  return (
    <TimelineStepsContainer>
      <TimelineStepsContainer.Line isMobile={isMobile} status={!!statusReleasedForDelivery} />
      <TimelineStepsContainer.StepsBox>
        {steps.map(step => (
          <TimelineStepsContainer.Item 
            saida={step.title === "Saída"}
            notPurple={!step.active && !step.purple}
            key={step.title}
          >
            <div style={{ marginBottom: isMobile ? 0 : 20, width: '50px', height: '40px' }}>
              {step.title === props.title &&
                <img style={isMobile ? { width: '40px', height: '30px' } : {}} className="truck" src={TruckIcon} alt="truck icon" />
              }
            </div>
            <TimelineStepsContainer.Step
              active={step.active}
              purple={step.purple}
              canceled={props.canceled}
            >
              {
                (props.canceled || !step.purple) ? null : (
                  <img
                    src={Check}
                    alt="Check"
                  />
                )
              }
              {
                step.title === "Saída" && step.active ? (
                  <img
                    src={Check}
                    alt="Check"
                  />
                ) : null
              }
            </TimelineStepsContainer.Step>
            <div className="box-text-step">
              <span className={step.active ? 'blue' : 'gray'}>
                {step.title}
              </span>
              <span>
                {step.active ? step.description : null}
                {
                  !step.active && step.title === "Pedido" && step.purple ?
                    "Pedido recebido" : null
                }
                {
                  !step.active && step.title === "Financeiro" && step.purple ?
                    "Liberado pelo financeiro" : null
                }
                {
                  !step.active && step.title === "Faturamento" && step.purple && !props.canceled ?
                    "Nota fiscal emitida" : null
                }
                {
                  !step.active && step.title === "Liberação" && step.purple && !props.canceled ?
                    "Liberado para entrega" : null
                }
              </span>
              <span
                className={
                  (step.date && step.purple) ||
                  (step.date && step.active) ? 'normal-color' : 'hide-item'
                }
              >
                {moment(
                  step.date
                ).format("DD/MM/YYYY")}
                {" "}
                {step.title === "Saída" && step.active && (
                  moment(
                    step.date
                  ).utc().format("HH:mm")
                )}
              </span>
            </div>
          </TimelineStepsContainer.Item>
        ))}
      </TimelineStepsContainer.StepsBox>
    </TimelineStepsContainer>
  );
}
